export default {
    data() {
        return {
            customViewConfig: [],
            customLabel: {}
        };
    },
    created() {
        if (this.autoLoadViewConfig !== false) {
            this.getViewConfig();
        }
    },
    methods: {
        /**
         * 加载自定义视图设置
         * @returns 
         */
        getViewConfig() {
            const me = this;
            let name = me.xtype, bizType = me.caller;
            if (!name || !bizType) {
                return;
            }
            me.$ajax({
                url: '/api/ui/customize/init',
                params: {
                    name,
                    bizType
                }
            }).then(function (res) {
                //let metadata = res?.data?.metadata;
                let metadata = res && res.data && res.data.metadata
                if (metadata) {
                    me.parseLabel(metadata);
                    me.customViewConfig = metadata;
                }
                
                let initControls = res && res.data && res.data.properties && res.data.properties.initControls
                if(initControls) {
                    me.pretreatment(initControls)
                }
            });
        },
        /**
         * 自定义名称
         * @param {*} metadata 
         */
        parseLabel(metadata) {
            let customLabel = {};
            metadata.forEach(item => {
                let fields = JSON.parse(item.content), name, label;
                for (let field of fields) {
                    name = field.name || field.dataIndex;
                    label = field.fieldLabel || field.text;
                    if (name && label) {
                        customLabel[name] = label;
                    }
                }
            });
            this.customLabel = customLabel;
        },
        /**
         * 
         * @param {*} initControls 
         */
        pretreatment(initControls) {
            let metadata = this.customViewConfig
            let keys = Object.keys(initControls)
            initControls = {
                main: [],
                items: [],
                items1: [],
                items2: []
            }
            
            let splited = []
            keys.forEach(item => {
                splited = item.split('.')
                initControls[splited[0]].push(splited[1])
            })

            initControls.items1 = initControls.items1.concat(initControls.items)
            initControls.detail1 = initControls.items1
            initControls.detail2 = initControls.items2
            delete initControls.items
            delete initControls.items1
            delete initControls.items2

            keys = Object.keys(initControls)
            keys.forEach(key => {
                if(initControls[key].length > 0) {
                    let index = metadata.findIndex(item => item.position == key)
                    if(index > -1) {
                        let fields = JSON.parse(metadata[index].content)
                        initControls[key].forEach(item => {
                            let i = fields.findIndex(ele => ele.name == item)
                            i > -1
                                ? fields[i].hidden = true
                                : fields.push({ name: item, hidden: true })
                            metadata[index].content = JSON.stringify(fields)
                        })
                    } else {
                        let contentArr = []
                        initControls[key].forEach(item => {
                            contentArr.push({
                                name: item,
                                hidden: true
                            })
                        })
                        metadata.push({
                            content: JSON.stringify(contentArr),
                            position: key
                        })
                    }
                }
            })
        },
        /**
         * @desc: 获取明细行必填项
         * @return {*}
         * @example: 
         */        
        getDetailRequired() {
            const metadata = JSON.parse(this.customViewConfig[1].content)
            const requiredMap = {}

            metadata.forEach(item => {
                if(item.allowBlank === false) {
                    requiredMap[item.dataIndex] = true
                }
            })

            return requiredMap
        }
    }
}